<template>
    <div class="dml-special-banners-wrap">
        <div class="dml-special-banners__highlighted" :style="backgroundStyle"></div>
        <dm-scrollable-list className="dml-special-banners"
                            innerClassName="dml-special-banners__list"
                            navClassName="dml-special-banners__nav"
                            :itemsInViewport="2">
            <template slot="items">
                <li class="dml-special-banners__item dml-special-banner" v-for="(item, index) in items">
                   <a :href="item.url"
                       class="dml-special-banner__wrapper"
                       :rel="item.rel"
                       data-ga="home.click_small_banner"
                       :data-ga-label="`${index + 1}_${item.alt}`">
                        <picture>
                            <source :srcset="`${item.pictures.large2x} 2x, ${item.pictures.large2x} 2x`" media="(min-width: 720px)" />
                            <img v-if="isSecondaryContent || index > 1"
                                 class="dml-special-banner__image lazy"
                                 src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                                 :data-srcset="`${item.pictures.small2x} 2x, ${item.pictures.small1x} 1x`"
                                 :alt="item.alt" />
                            <img v-else
                                 class="dml-special-banner__image"
                                 :src="item.pictures.small1x"
                                 :srcset="`${item.pictures.small2x} 2x, ${item.pictures.small1x} 1x`"
                                 :alt="item.alt" />
                        </picture>
                    </a>
                </li>
            </template>
        </dm-scrollable-list>
    </div>
</template>
<script>
    import { isHighDensity } from '~/utils/high-resolution';
    import * as screenSizes from '~/utils/screen-sizes';
    import ScrollableListComponent from '../shared/scrollable-list-component.vue';
    import IconComponent from '../shared/icon-component.vue';

    export default {
        name: 'dm-special-banners',
        components: {
            'dm-icon': IconComponent,
            'dm-scrollable-list': ScrollableListComponent,
        },
        props: {
            items: {
                type: Array,
                required: true
            },
            slots: {
                type: Number,
                default: 2
            },
            preload: {
                type: Object,
                default: null
            },
            backgroundColor: {
                type: String,
                default: '#000000'
            }
        },
        created() {
            if (this.preload) {
                this.preloadImages();
            }
        },
        computed: {
            backgroundStyle() {
                return `background-color:${this.backgroundColor}`;
            },
            isSecondaryContent() {
                return !!DM.Boot.MainPage.mainPageBanners;
            },
        },
        methods: {
            preloadImages() {
                if (this.preload.sequentially) {
                    this.preloadImagesSeq(1);
                }
            },
            preloadImagesSeq(position) {
                const item = this.items.filter((item, index) => index === position)[0];
                if (item) {
                    const img = new Image();
                    img.src = this.getImageToPreload(item);
                    img.onload = () => {
                        const newPosition = position + 1;
                        if (this.items.length > newPosition) {
                            this.preloadImagesSeq(newPosition);
                        }
                    };
                }
            },
            getImageToPreload(banner) {
                if (screenSizes.isSmallScreen()) {
                    return isHighDensity ? banner.pictures.small2x : banner.pictures.small1x;
                } else {
                    return isHighDensity ? banner.pictures.large2x : banner.pictures.large1x;
                }
            },
        },
    };
</script>
